<template>
  <svg class="icon" aria-hidden="true" v-on="$listeners">
    <use :href="`#${iconName}`" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName() {
      return this.iconClass
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue